module.exports = __webpack_public_path__ + "static/img/cf-flow.91ca7d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/cf-flow.svg
// module id = f3py
// module chunks = 19